/* eslint-disabled */

export default class PrintableModelExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
